module.exports = __webpack_public_path__ + "img/guide_dog.d93dd865.png";